import React from 'react';
import classNames from 'classnames';

import './HoverBadge.sass';

interface HoverBadgeProps {
  href: string;
  title: string;
  className: string;
  innerContent: string;
  children: React.ReactNode;
}

const HoverBadge = ({
  href = '#',
  title = '',
  className,
  innerContent,
  children
}: HoverBadgeProps) => {
  const hoverBadgeClassNames = classNames('hover-badge', className);

  return (
    <a href={href} className={hoverBadgeClassNames} title={title}>
      <div className="hover-badge__circle-wrapper">
        <div className="hover-badge__circle">{innerContent}</div>
      </div>

      {children && (
        <div
          className="hover-badge__text"
          dangerouslySetInnerHTML={{ __html: children }}
        />
      )}
    </a>
  );
};

export default HoverBadge;
